import { h } from "preact";
import { FilterIcon, SelectedCheckSmall } from "../helpers/icons";

export default function BlogSort({ reverse, setReverse }) {
  const setSortParam = (value) => {
    const newUrl = new URL(window.location);
    newUrl.searchParams.set("sort_by", value);
    window.history.pushState(null, "", newUrl);
  };

  const sortOptions = [
    {
      setActive: () => {
        setSortParam("newest");
        setReverse(false);
      },
      active: !reverse,
      text: "Newest",
    },
    {
      setActive: () => {
        setSortParam("oldest");
        setReverse(true);
      },
      active: reverse,
      text: "Oldest",
    },
  ];

  return (
    <details className="main-blog__sort-details">
      <summary className="main-blog__sort-summary">
        <FilterIcon />
        Sort By
      </summary>
      <ul className="main-blog__sort">
        {sortOptions.map((option) => (
          <li>
            <button
              type="button"
              onClick={option.setActive}
              className="main-blog__sort-option"
            >
              {option.active && <SelectedCheckSmall />}
              {option.text}
            </button>
          </li>
        ))}
      </ul>
    </details>
  );
}
